export default "__VITE_ASSET__DIjMC5It__"